// src/components/ViecChuNha.js
import React from "react";

// ============================================================
// 📋 VIỆC CỦA CHỦ NHÀ — đầu trang ⚙️ Quản trị (Đợt N5, 14/09/2026)
// ------------------------------------------------------------
// Anh chốt: *"Bảng tin là bảng tin chung. Công việc 'riêng' của tôi nên dọn
// về quản trị hệ thống và báo (đỏ ở đó)."*
//
// Mỗi dòng là một TÌNH TRẠNG máy chủ tính ra (viec-chu-nha.js), không phải
// lời nhắc lưu sẵn: anh làm xong việc (tải về, cất sao lưu) thì dòng tự hết,
// số đỏ trên nút ⚙️ giảm theo. Không có nút "tắt".
//
// Không có việc gì thì KHÔNG hiện khung — khung trống "không có gì" chỉ
// chiếm chỗ của bảng thành viên bên dưới.
// ============================================================
function ViecChuNha({ viec }) {
  if (!viec || viec.length === 0) return null;

  const cuonToi = (id) => {
    const o = document.getElementById(id);
    if (o) o.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="viec-chu-nha">
      <h3 className="viec-chu-nha-tieu-de">📋 Việc của chủ nhà</h3>
      {viec.map((v, i) => (
        <button
          key={`${v.loai}-${i}`}
          className={`viec-chu-nha-dong ${v.loai === "sao_luu_hong" ? "viec-chu-nha-hong" : ""}`}
          onClick={() => cuonToi(v.toi)}
        >
          {v.chu}
          <span className="viec-chu-nha-toi">
            {{ "kho-anh": "Xuống Kho ảnh ↓", "khoan-co-dinh": "Xuống Khoản cố định ↓" }[v.toi] || "Xuống Sao lưu ↓"}
          </span>
        </button>
      ))}
      <p className="viec-chu-nha-ghi">
        Làm xong thì dòng tự hết, số đỏ giảm theo — không cần bấm tắt.
      </p>
    </div>
  );
}

export default ViecChuNha;
